import { Component, OnInit } from '@angular/core';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-translation-tab',
    templateUrl: './translation-tab.component.html',
    styleUrls: ['./translation-tab.component.scss']
})
export class TranslationTabComponent implements OnInit {

    @Input()
    titleName: string ='';

    @Input()
    bindingAttribute: string = '';

    @Input()
    translationArray:any[] = [];

    @Output()
    translationArrayChange = new EventEmitter<any>();

    languages: any[];

    constructor(public globalData: GlobalDataService) {
    }

    ngOnInit(): void {
        this.languages = this.globalData.globalData.languages;
    }

    changeInput($event, lang, key) {
        this.translationArray[lang][key] = $event.target.value;
        this.translationArrayChange.emit(this.translationArray);
    }

}
